export default "__VITE_ASSET__92e13c86__"